<template>
    <div v-if="series">
        <CardRowText
            :label="$t('company-group')"
            :text="valueToString(series.companyGroup)"
            :has-border-bottom="true"
        />
        <CardRowText
            :label="$t('business-domain')"
            :text="valueToString(series.businessDomain)"
            :has-border-bottom="true"
        />
        <CardRowText :label="$t('department')" :text="valueToString(series.department)" :has-border-bottom="true" />
        <CardRowText
            :label="$t('organisational-changes')"
            :text="valueToString(series.organisationalChanges)"
            :has-border-bottom="false"
        />
    </div>
</template>
<script setup lang="ts">
import CardRowText from '@/components/Card/CardRowText.vue';
import { useEventSeries } from '@/event/composables/useEventSeries';
import { valueToString } from '@/forms/forms';
import { computed } from 'vue';

const props = defineProps<{ seriesId: string }>();

const seriesId = computed(() => props.seriesId);
const { series } = useEventSeries(seriesId);
</script>
